module.exports = __webpack_public_path__ + "img/SMP_profil-165303932-1400x900.6b7bd2c0.jpg";